<template>
	<div class="product-listing">
		<div class="container">
			<div class="product-listing__wrap" v-if="noResults === 0">
				<PartProductPost v-for='(product, index) in products' :key="index" v-bind:product='product' hasFeeds imgName='food-1.jpg' @click='handleClick(index, $event)'/>
			</div>
			<div class="item-listing__wrap no-products-found-wrap" v-if="noResults !== 0">
				{{ noResults }}
			</div>

			<div class="spinner-container" v-if="showSpinner">
				<SvgIcon class="ico-spinner color-happy-blue" iconName="ico-spinner"/>
			</div>
		</div>
		<BlockPopupProductSlide :show="show" :product="product" @click="show = $event"/>
	</div>
</template>

<script>
	import PartProductPost from '../parts/PartProductPost.vue';
	import SvgIcon from '../base/SvgIcon/SvgIcon.vue';
	import BlockPopupProductSlide from './BlockPopupProductSlide.vue';

	export default {
		beforeMount() {
			this.showSpinner = true;
			this.$store.dispatch('setProducts', {type: this.categoryName, category: this.categoryFlag});
		},
		components: {
			PartProductPost,
			SvgIcon,
			BlockPopupProductSlide
		},
		data() {
			return {
				showSpinner: true,
				show: false,
				scrollPosition: 0,
				product: {},
				// eslint-disable-next-line no-undef
				categoryFlag: productCategory,
				// eslint-disable-next-line no-undef
				categoryName: categoryName,
				noResults: 0
			};
		},
		computed: {
			products() {
				// eslint-disable-next-line vue/no-side-effects-in-computed-properties
				this.showSpinner = false;
				// eslint-disable-next-line consistent-this
				const $this = this;
				const results = this.$store.getters.getProducts;
				if (null !== results && Object.keys(results).length === 0) {
					// eslint-disable-next-line vue/no-side-effects-in-computed-properties
					this.noResults = 'There are no products found.';
				}
				// eslint-disable-next-line vue/no-async-in-computed-properties
				setTimeout(function() {
					$this.showSpinner = false;
				}, 1000);
				return results;
			}
		},
		methods: {
			handleClick: function(index, event) {
				this.show = event;
				this.selectProduct(index);
			},
			// searchResults: function(results) {
			// 	this.products = results;
			// 	console.log(results);
			// },
			selectProduct(productOrder) {
				this.product = this.products[productOrder];
			}
		},
		watch: {
			show: function() {
				if (this.show) {
					const $body = document.querySelector('body');
					$body.classList.add('body-lock');
					this.scrollPosition = window.pageYOffset;
					$body.style.overflow = 'auto';
					$body.style.position = 'fixed';
					$body.style.top = `-${this.scrollPosition}px`;
					$body.style.width = '100%';
					return;
				}
				const $body = document.querySelector('body');
				$body.classList.remove('body-lock');
				$body.style.removeProperty('overflow');
				$body.style.removeProperty('position');
				$body.style.removeProperty('top');
				$body.style.removeProperty('width');
				window.scrollTo(0, this.scrollPosition);
			}
		}
	};
</script>

<style lang="scss" scoped>
	.product-listing {
		margin-top: 62px;
	}

	.product-listing__wrap {
		display: flex;
		flex-wrap: wrap;
		align-items: stretch;
	}

	.spinner-container {
		margin-top: 10px;
		display: flex;
		justify-content: center;
	}

	.ico-spinner {
		font-size: 26px;
		animation-name: spinner-rotation;
		animation-duration: 1.5s;
		animation-iteration-count: infinite;
		animation-timing-function: linear;
	}

	@keyframes spinner-rotation {
		0% {
			transform: rotate(0);
		}

		100% {
			transform: rotate(1turn);
		}
	}
</style>
